import * as angular from 'angular';

class NetworkPointDetailsOperatorInfoChargesComponentCtrl
    implements ng.IController
{
    public isCreateMode: boolean;
    public isEditMode: boolean;
    public feesExpanded: boolean = true;
    public networkPoint: NetworkPointDto;
    public possibleRuntimes: any = ['HOUR'];
    public possiblePhysicalUnits = ['K_WH_H'];
    public loadingCurrencies: boolean = true;
    public loadingCurrenciesError: boolean = false;
    private possibleCurrencies: any;

    public addRegulatedTariff: boolean = false;
    public newRegulatedTariff: PriceDto;
    public newRegulatedTariffRuntime: DateInterval;

    constructor(private StaticData) {}

    $onInit(): void {
        if (this.isCreateMode) {
            this.getCurrencies();
            // fix NWP currency if it is potentially broken
            if (this.networkPoint.chargesDto.commodityFee0) {
                this.networkPoint.chargesDto.commodityFee0.originalUnit.unspecificPeriod = false;
                this.networkPoint.chargesDto.commodityFee0.originalUnit.periodType =
                    'HOUR';
                this.networkPoint.chargesDto.commodityFee0.originalUnit.physicalUnit =
                    'K_WH_H';
            }
            if (this.networkPoint.chargesDto.commodityFee1) {
                this.networkPoint.chargesDto.commodityFee1.originalUnit.unspecificPeriod = false;
                this.networkPoint.chargesDto.commodityFee1.originalUnit.periodType =
                    'HOUR';
                this.networkPoint.chargesDto.commodityFee1.originalUnit.physicalUnit =
                    'K_WH_H';
            }
        }
    }

    private getCurrencies(): void {
        this.StaticData.currenciesForProductUpload(
            (res) => {
                this.possibleCurrencies = res.reverse();
                this.loadingCurrencies = false;
                this.loadingCurrenciesError = false;
            },
            () => {
                this.loadingCurrencies = true;
                this.loadingCurrenciesError = true;
            }
        );
    }
}

angular
    .module('app')
    .component('pkpNetworkPointDetailsOperatorInfoChargesCapacityManagement', {
        controller: NetworkPointDetailsOperatorInfoChargesComponentCtrl,
        template:
            require('app/network-point/network-point-details-operator-info-charges-capacity-management.component.html'),
        bindings: {
            form: '=',
            networkPoint: '=',
            isEditMode: '<',
            isCreateMode: '<'
        }
    });
